// extracted by mini-css-extract-plugin
export default {"intro":"MovieContainer_intro__voclp","fadeOut":"MovieContainer_fadeOut__FATRR","hideContainer":"MovieContainer_hideContainer__C-Ia9","mainh1":"MovieContainer_mainh1__ls200"};